const MONTHS = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
]

// Formats an ISO date deterministically in UTC so server and client render identically.
export function formatDate(iso: string): string {
    const date = new Date(iso)

    if (Number.isNaN(date.getTime())) return ''

    return `${MONTHS[date.getUTCMonth()]} ${date.getUTCDate()}, ${date.getUTCFullYear()}`
}
